import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { filter } from 'lodash';
// utils
import { PURGE } from 'redux-persist';
import { headers, saltmineJsonHeader, saltmineJwtHeaders, urls } from 'src/libs/reqConf';
import { checkTokenAndRefresh, errorHandle } from 'src/utils/function';
import { getCloseLoading, getLoading } from './loading';
import { setError } from './modal';
import { changeMyProfile } from './user';

// ----------------------------------------------------------------------
// 네트워크 기관
const initialState = {
  isLoading: false,
  notifications: {}
};

const slice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    settingsReset(state) {
      // immer를 사용하여 직접 상태를 수정
      Object.assign(state, initialState);
    },
    getNotificationsSuccess(state, action) {
      state.notifications = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { openModal, closeModal, selectEvent, updateCurrentChannel, settingsReset } = slice.actions;




// ---------------------------------------------------------------------
// 카카오 연동
export function postKakaoConnect({ kakaoAuthCode }) {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      const url = `${urls.user}/settings/kakao/connect`;
      let accessToken = window.localStorage.getItem('accessToken');
      const body = { kakaoAuthCode };
      const config = { headers: headers(accessToken) };
      const response = await axios.post(url, body, config);

      dispatch(changeMyProfile(response.data.data));
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ---------------------------------------------------------------------
// 카카오 연동 해제
export function postKakaoDisconnect({ kakaoAuthCode }) {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      const url = `${urls.user}/settings/kakao/disconnect`;
      let accessToken = window.localStorage.getItem('accessToken');
      const body = { kakaoAuthCode };
      const config = { headers: headers(accessToken) };
      const response = await axios.post(url, body, config);

      dispatch(changeMyProfile(response.data.data));
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}
